import { useEffect, useRef, useState } from "react"

function format(totalSeconds: number): string {
  const pad = (n: number) => n.toString().padStart(2, "0")
  const h = Math.floor(totalSeconds / 3600)
  const m = Math.floor((totalSeconds % 3600) / 60)
  const s = totalSeconds % 60
  return `${pad(h)}:${pad(m)}:${pad(s)}`
}

/** Count-up chat timer that runs only while `isCounting` is true. */
export function useChatTimer({ isCounting }: { isCounting: boolean }) {
  const [seconds, setSeconds] = useState(0)
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null)

  useEffect(() => {
    if (isCounting && !intervalRef.current) {
      intervalRef.current = setInterval(() => setSeconds((p) => p + 1), 1000)
    }
    if (!isCounting && intervalRef.current) {
      clearInterval(intervalRef.current)
      intervalRef.current = null
    }
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
        intervalRef.current = null
      }
    }
  }, [isCounting])

  return { chatTimeUi: format(seconds) }
}
